import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Spinner } from 'react-bootstrap';
import dbService from '../../../services/dbService';
import PageContainer from '../../layout/PageContainer';
import OnboardingScreening from './OnboardingScreening';
import PerpetualScreening from './PerpetualScreening';
import TransactionScreening from './TransactionScreening';
import WatchlistManager from './WatchlistManager';

const ScreeningStudio = () => {
    const [watchlists, setWatchlists] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async () => {
        setIsLoading(true);
        setWatchlists(await dbService.getAll('watchlists'));
        setIsLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (isLoading) return <div className="text-center p-5"><Spinner animation="border" /></div>;

    return (
        <PageContainer title="Screening Studio">
            <Tabs defaultActiveKey="onboarding" id="screening-tabs" className="mb-3" justify>
                <Tab eventKey="onboarding" title="Onboarding & Ad-Hoc">
                    <div className="p-3 border border-top-0">
                        <OnboardingScreening watchlists={watchlists} />
                    </div>
                </Tab>
                <Tab eventKey="perpetual" title="Perpetual Screening">
                    <div className="p-3 border border-top-0">
                        <PerpetualScreening watchlists={watchlists} />
                    </div>
                </Tab>
                <Tab eventKey="transaction" title="Transaction Screening">
                    <div className="p-3 border border-top-0">
                        <TransactionScreening watchlists={watchlists} />
                    </div>
                </Tab>
                <Tab eventKey="watchlist" title="Watchlist Management">
                    <div className="p-3 border border-top-0">
                        <WatchlistManager watchlists={watchlists} onUpdate={fetchData} />
                    </div>
                </Tab>
            </Tabs>
        </PageContainer>
    );
};

export default ScreeningStudio;